// Role registry: maps Kinde org_code claims to internal roles.
//
// Today only the InRange staff org has a role (``admin``). Future
// orgs (landlord, tenant, EPC, etc.) get added here and the matching
// UI guards reference the same ``Role`` union. The backend has a
// mirror at ``src/inrange_agents/auth/roles.py`` - keep them in
// lockstep so a route that the frontend gates also gets gated on
// the API side.
import { KINDE_CONFIG } from "./kindeConfig";

export type Role = "admin";

const ORG_ROLES: Record<string, Role> = {
  // The InRange staff org. The actual org_code value comes from
  // KINDE_CONFIG.orgCode (per-env: dev/qa = org_930bea1210ea,
  // prod = org_4dd2d1370b1) so we don't hardcode it here.
  [KINDE_CONFIG.orgCode]: "admin",
};

export function roleForOrgCode(
  orgCode: string | undefined | null,
): Role | null {
  if (!orgCode) return null;
  return ORG_ROLES[orgCode] ?? null;
}
